module.exports = __webpack_public_path__ + "img/Beta.b0691796.png";